export const enClientPortalPlausibilityPdf = {
    loading: 'Loading document ...',
    actions: {
        previousPage: 'Previous page',
        nextPage: 'Next page',
        zoomOut: 'Zoom out',
        zoomIn: 'Zoom in',
        highlight: 'Highlighter',
        downloadDraft: 'Download draft',
        newPageAnnotation: 'New comment on this page',
    },
    search: {
        placeholder: 'Search PDF',
        results: '{{current}} of {{total}} {{resultLabel}}',
        resultSingle: 'result',
        resultPlural: 'results',
        previousResult: 'Previous result',
        nextResult: 'Next result',
        reset: 'Reset search',
    },
}
